import { useDeptTreeList } from "@/hooks/services";
import { Empty, Radio, Tree } from "antd";
import { useModalBody } from "./hooks/useModalBody";
import styles from "./index.module.less";
import type { DeptItem, OperationEvent } from "./type";

type ModalBodyProps = {
  selectedDept?: DeptItem | null;
  setSelectedDept?: (dept: DeptItem | null) => void;
  searchedList: DeptItem[];
  reset: () => void;
  eventType: OperationEvent;
  setEventType: (event: OperationEvent) => void;
};

export const ModalBody: React.FC<ModalBodyProps> = ({
  selectedDept,
  setSelectedDept,
  searchedList,
  reset,
  eventType,
  setEventType,
}) => {
  const { pendingDepts, setPendingDepts, radioOptions } = useModalBody(
    searchedList,
    eventType,
  );

  const { deptTreeData } = useDeptTreeList();

  const onDeptChange = (e: any) => {
    const deptNo = e.target.value;
    const dept = pendingDepts.find((d) => d.deptNo === deptNo) || null;
    setSelectedDept?.(dept);
  };

  const onSelect = (_selectedKeys: React.Key[], info: any) => {
    let newDepts: DeptItem[] = [];
    if (info.node.children?.length === 0) {
      newDepts = [
        {
          deptName: info.node.title,
          deptNo: info.node.key,
        },
      ];
    } else {
      newDepts = (info.node.children || []).map((child: any) => ({
        deptName: child.title,
        deptNo: child.key,
      }));
    }
    setPendingDepts(newDepts);
    setSelectedDept?.(null);
    reset();
    setEventType("treeSelect");
  };

  return (
    <div className={styles.panelContainer}>
      <div className={styles.leftPanel}>
        <Tree showLine={true} onSelect={onSelect} treeData={deptTreeData} />
      </div>
      <div className={styles.rightPanel}>
        <Radio.Group
          className={styles.deptGroup}
          onChange={onDeptChange}
          value={selectedDept?.deptNo}
          options={radioOptions}
        />

        {pendingDepts.length === 0 && <Empty style={{ marginTop: 80 }} />}
      </div>
    </div>
  );
};
